import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
function Dbi() {
  const cellStyle = {
    borderBottomColor: "black",
    borderBottomStyle: "solid",
    borderBottomWidth: 1,
  };
  const cellComplementStyle = {
    borderRightStyle: "solid",
    borderRightColor: "black",
    borderRightWidth: 1,
  };
  const materiasDocente = [
    {
      materia: "Fundamentos de Biotecnología",
      horas: 140,
      docente: "Danitza Xiomara Romero Calle, PhD.",
    },
    {
      materia: "Biotecnología Blanca e Ingeniería de Bioprocesos",
      horas: 140,
      docente: "Danitza Xiomara Romero Calle, PhD.",
    },
    {
      materia: "Diseño Experimental y Análisis de Datos en Biotecnología",
      horas: 140,
      docente: "Carlos Molina Arzabe, PhD.",
    },
    {
      materia:
        "Bioprocesos, Fermentación y la Industria de Alimentos y Bebidas",
      horas: 140,
      docente: "Ing. Roxana Felicidad Apaza Jurado",
    },
    {
      materia: "Biotecnología en Bioenergía y Medio Ambiente",
      horas: 140,
      docente: "Lic. April Isabel Villegas Cusi",
    },
    {
      materia: "Gestión de Proyectos y Bioemprendimientos",
      horas: 140,
      docente: "Ing. M.Sc. Roxana Pacovich Michaga",
    },
    {
      materia: "Asesoría y elaboración de Monografía",
      horas: 140,
      docente: "Ing. M.Sc. Paola Arjuna Requerin López",
    },
  ];
  return (
    <TableContainer
      sx={{
        borderWidth: 1,
        borderStyle: "solid",
        borderRadius: 1,
        marginY: 2,
      }}
    >
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell
              align="center"
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              <strong>MÓDULO</strong>
            </TableCell>
            <TableCell
              align="center"
              sx={{
                ...cellStyle,
                ...cellComplementStyle,
              }}
            >
              <strong>HORAS ACADÉMICAS</strong>
            </TableCell>
            <TableCell sx={cellStyle}>
              <strong>DOCENTES</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {materiasDocente.map((item, index) => (
            <TableRow key={index}>
              <TableCell
                sx={{
                  ...cellStyle,
                  ...cellComplementStyle,
                }}
              >
                {item.materia}
              </TableCell>
              <TableCell
                sx={{
                  ...cellStyle,
                  ...cellComplementStyle,
                }}
                align="center"
              >
                {item.horas}
              </TableCell>
              <TableCell sx={{ ...cellStyle }}>{item.docente}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default Dbi;
